<template>
  <div id="additional-products">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button icon="fas fa-clipboard-check" type="warning" size="small" round @click="recordsDialog = !recordsDialog"> {{ $t("registrationManagement.subeventRegistrations.records") }} ({{ $store.state.additionalProducts.filter.pendingRegistration }})</el-button>
          </li>
          <li class="nav-item">
            <el-dropdown stlye="height: 32px;">
              <el-button size="small" type="warning" round>
                <i style="font-size: 12px;" class="fas fa-exchange-alt"></i>
                {{ $t("event.components.participants.navbar.transfer.title") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="importExcell(4)">
                  <i class="fas fa-upload"></i>
                  {{ $t("event.components.participants.navbar.transfer.import") }}
                </el-dropdown-item>
                <!-- <el-dropdown-item @click.native="openExcellDialog">
									<i class="fas fa-download"></i>
									{{ this.$t('event.components.participants.navbar.transfer.export') }}
								</el-dropdown-item> -->
                <el-dropdown-item v-for="(item, index) in products" @click.native="downloadTemplate(item.id)" :key="index" :divided="index == 0 ? true : false">
                  <i class="fas fa-file-excel"></i>
                  {{ item.title }} {{ $t("event.components.participants.navbar.transfer.transferDraft") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('event.components.participants.navbar.transfer.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.subevents.filter.searchTerm != '' && $store.state.subevents.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button icon="fas fa-plus" type="primary" size="small" :loading="loading == 'createSub'" round @click="createProduct"> {{ $t("registrationManagement.additionalProducts.createProduct") }}</el-button>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("registrationManagement.additionalProducts.filter") }}</h5>
                <span>{{ $t("registrationManagement.additionalProducts.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="filter.searchTerm = null" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="filter.searchTerm" :placeholder="$t('registrationManagement.additionalProducts.searchPlaceholder')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("registrationManagement.additionalProducts.title") }}</h5>
              <span v-if="filter.totalCount > 0" v-html="$t('totalContent', [filter.totalCount])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="filter.totalCount > 0">
            <div class="custom-grid-table-header product-list-header">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <span>{{ $t("registrationManagement.additionalProducts.headerTitle") }}</span>
              <el-tooltip effect="dark" placement="top-start">
                <div class="tooltip-wrapper" slot="content">{{ $t("registrationManagement.additionalProducts.capacityMsg") }}</div>
                <span>{{ $t("registrationManagement.additionalProducts.capacity") }}<i class="el-icon-info"></i></span>
              </el-tooltip>
              <div>{{ $t("registrationManagement.additionalProducts.view") }}</div>
              <span></span>
            </div>
            <draggable :list="products" tag="div" handle=".el-icon-s-grid" class="list-group-o product-list-container" v-bind="dragOptions" @start="dragList = true" @end="changeProductOrder">
              <div class="item" v-for="item in products" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="table-icon">
                  <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                </div>
                <div class="img-title">
                  {{ item.title }}
                </div>
                <div class="limit">
                  <span class="isLimited" v-if="item.enableStockControl" :class="item.stock <= item.usage ? 'isOver' : ''"
                    >{{ item.stock }} <b>/ {{ item.usage }}</b></span
                  >
                  <span class="isCool" v-else><i class="fas fa-infinity"></i></span>
                </div>
                <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item)"></el-switch></div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        productId = item.id;
                        addNewProduct = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteProductItem' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-additional-products-lottie'" :title="$t('registrationManagement.additionalProducts.title')" @btnAdd="createProduct" @btnRefresh="refreshList()" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" :visible.sync="addNewProduct" :title="$t('event.tags.addNewProduct')" class="large" center modal-append-to-body destroy-on-close>
        <AdditionalProductAddUpdate @closeDialog="addNewProduct = false" @deleteMe="deleteItem" :id="productId" v-if="addNewProduct" />
      </el-dialog>
      <el-dialog class="large" :visible.sync="recordsDialog" :title="$t('registrationManagement.additionalProducts.productRecords')" center modal-append-to-body destroy-on-close :close-on-click-modal="false">
        <ProductRecords v-if="recordsDialog" @closeDialog="recordsDialog = false" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import AdditionalProductAddUpdate from "../../components/AdditionalProductAddUpdate.vue";
import ProductRecords from "./ProductRecords.vue";
export default {
  components: {
    draggable,
    AdditionalProductAddUpdate,
    ProductRecords
  },
  data() {
    return {
      addNewProduct: false,
      productId: null,
      isFilterEnabled: false,
      dragList: false,
      timeout: null,
      loading: null,
      recordsDialog: null,
      helpUrl: this.$helpUrl + "speaker"
    };
  },
  async created() {
    await this.$store.dispatch("getProducts");
  },
  beforeMount() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getSubEvents");
      this.$store.dispatch("getTags");
      this.$store.dispatch("getRegisterForm");
      this.loading = false;
    }, 500);
  },
  methods: {
    async downloadTemplate(id) {
      this.$message.info(this.$t("generic.generatingPleaseWait"));
      var res = await this.$store.dispatch("exportXlscx", { type: 18, itemId: id, queryJson: null });
      if (!res.data.alert.hasError) {
        window.open(res.data.data.url, "_blank");
      }
    },
    async toggleItem(item) {
      this.loading = item.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("toggleProductShow", item.id);
        if (!res.data.alert.hasError) {
          item.isActive = res.data.data.isActive;
        }
        this.loading = false;
      }, 500);
      setTimeout(() => {}, "500");
    },

    createProduct() {
      this.productId = null;
      this.addNewProduct = true;
    },
    async changeProductOrder() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "loadingList";
      this.timeout = setTimeout(async () => {
        var payload = [];
        this.products.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("updateProductsOrder", payload);
        await this.$store.dispatch("getProducts");
        this.loading = false;
      }, 500);
      this.dragList = false;
    },
    async refreshList() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "loadingList";
      await this.$store.dispatch("getProducts");
      this.timeout = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    async deleteItem(id) {
      this.loading = "deleteProductItem" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteProduct", id);
        this.loading = false;
      }, 500);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    products() {
      return this.$store.getters.getProducts;
    },
    filter() {
      return this.$store.getters.getProductFilter;
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store.dispatch("getProducts");
        }, 500);
      }
    }
  }
};
</script>

<style lang="less">
#additional-products {
  .product-list-header {
    grid-template-columns: 36px 3fr 1fr 90px 90px;
  }
  .product-list-container {
    display: flex;
    flex-direction: column;
    .item {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: unset;
      }

      .img-title {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        line-height: normal;

        & > img {
          border-radius: 50%;
          width: 45px;
          height: 45px;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
        }
      }
      .limit {
        font-weight: 500;
        color: #292f3b;

        .isLimited {
          color: #505763;
          &.isOver {
            color: #ff6565;

            b {
              color: #ff6565 !important;
            }
          }

          b {
            color: #292f3b;
            font-weight: 600;
          }
        }

        .isCool {
          color: #03658c;

          i {
            font-size: 14px;
          }
        }

        .isMobileActive {
          color: #03658c;
          b {
            font-weight: 600;

            &.autoDisabled {
              color: #292f3b;
            }
          }
        }

        .isMobilePassive {
          color: #ff6565;
        }
      }
      transition: all 0.5s;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      background-color: #f1f1f1;

      &.passive {
        background-color: #fff2f2 !important;
      }

      display: grid;
      grid-template-columns: 36px 3fr 1fr 90px 90px;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;

      gap: 0.5rem;
      & > .price-title {
        font-weight: bold;
        flex-direction: row;
        gap: 0.5rem;
        .el-input {
          width: 100%;
        }
      }
      .el-input-number {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
        &.me {
          color: #ccc;
        }
      }
      & > .title {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > i.el-icon-loading {
          font-size: 20px;
        }
      }

      & > div:last-child {
        justify-self: flex-end;
      }
      .table-icon {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/AdditionalProducts.vue